import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadCommitteeRegularInvitee: ICommitteeRegularInviteeLoadActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_LOAD,
            committeeId
        }
    },
    LoadCommitteeRegularInviteeById: ICommitteeRegularInviteeLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID,
            id
        }
    },
    LoadCommitteeRegularInviteeByCommitteeId: ICommitteeRegularInviteeLoadByCommitteeIdActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID,
            committeeId
        }
    },
    LoadSuccess: ICommitteeRegularInviteeLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ICommitteeRegularInviteeLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveCommitteeRegularInvitee: ICommitteeRegularInviteeSaveActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_SAVE,
            formData
        }
    },
    SaveSuccess: ICommitteeRegularInviteeSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ICommitteeRegularInviteeSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateCommitteeRegularInvitee: ICommitteeRegularInviteeCreateActionCreator = (committeeId) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_CREATE,
            committeeId
        }
    },
    CreateSuccess: ICommitteeRegularInviteeCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ICommitteeRegularInviteeCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateCommitteeRegularInvitee: ICommitteeRegularInviteeValidateActionCreator = (formData) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ICommitteeRegularInviteeValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ICommitteeRegularInviteeValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ICommitteeRegularInviteeClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ICommitteeRegularInviteeFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_COMMITTEEREGULARINVITEE_FILTER,
            formFilter
        }
    };



export const
    ACTION_COMMITTEEREGULARINVITEE_LOAD = "ACTION_COMMITTEEREGULARINVITEE_LOAD",
    ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID = "ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID",
    ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID = "ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID",
    ACTION_COMMITTEEREGULARINVITEE_LOAD_SUCCESS = "ACTION_COMMITTEEREGULARINVITEE_LOAD_SUCCESS",
    ACTION_COMMITTEEREGULARINVITEE_LOAD_FAILURE = "ACTION_COMMITTEEREGULARINVITEE_LOAD_FAILURE",

    ACTION_COMMITTEEREGULARINVITEE_SAVE = "ACTION_COMMITTEEREGULARINVITEE_SAVE",
    ACTION_COMMITTEEREGULARINVITEE_SAVE_SUCCESS = "ACTION_COMMITTEEREGULARINVITEE_SAVE_SUCCESS",
    ACTION_COMMITTEEREGULARINVITEE_SAVE_FAILURE = "ACTION_COMMITTEEREGULARINVITEE_SAVE_FAILURE",

    ACTION_COMMITTEEREGULARINVITEE_CREATE = "ACTION_COMMITTEEREGULARINVITEE_CREATE",
    ACTION_COMMITTEEREGULARINVITEE_CREATE_SUCCESS = "ACTION_COMMITTEEREGULARINVITEE_CREATE_SUCCESS",
    ACTION_COMMITTEEREGULARINVITEE_CREATE_FAILURE = "ACTION_COMMITTEEREGULARINVITEE_CREATE_FAILURE",

    ACTION_COMMITTEEREGULARINVITEE_VALIDATE = "ACTION_COMMITTEEREGULARINVITEE_VALIDATE",
    ACTION_COMMITTEEREGULARINVITEE_VALIDATE_SUCCESS = "ACTION_COMMITTEEREGULARINVITEE_VALIDATE_SUCCESS",
    ACTION_COMMITTEEREGULARINVITEE_VALIDATE_FAILURE = "ACTION_COMMITTEEREGULARINVITEE_VALIDATE_FAILURE",

    ACTION_COMMITTEEREGULARINVITEE_CLEAR = "ACTION_COMMITTEEREGULARINVITEE_CLEAR",

    ACTION_COMMITTEEREGULARINVITEE_FILTER = "ACTION_COMMITTEEREGULARINVITEE_FILTER";

export interface ICommitteeRegularInviteeLoadAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_LOAD";
    committeeId: number;
}

export interface ICommitteeRegularInviteeLoadActionCreator {
    (committeeId: number): ICommitteeRegularInviteeLoadAction;
}

export interface ICommitteeRegularInviteeLoadSuccessAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_LOAD_SUCCESS";
    formData: Dtos.CommitteeRegularInvitee | Dtos.CommitteeRegularInvitee[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeRegularInviteeLoadSuccessActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee | Dtos.CommitteeRegularInvitee[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeRegularInviteeLoadSuccessAction;
}

export interface ICommitteeRegularInviteeLoadFailureAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeRegularInviteeLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeRegularInviteeLoadFailureAction;
}

export interface ICommitteeRegularInviteeLoadByIdAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID";
    id: number;
}

export interface ICommitteeRegularInviteeLoadByIdActionCreator {
    (id: number): ICommitteeRegularInviteeLoadByIdAction;
}

export interface ICommitteeRegularInviteeLoadByCommitteeIdAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID";
    committeeId: number;
}

export interface ICommitteeRegularInviteeLoadByCommitteeIdActionCreator {
    (committeeId: number): ICommitteeRegularInviteeLoadByCommitteeIdAction;
}

export interface ICommitteeRegularInviteeSaveAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_SAVE";
    formData: Dtos.CommitteeRegularInvitee;

}

export interface ICommitteeRegularInviteeSaveActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee
    ): ICommitteeRegularInviteeSaveAction;
}

export interface ICommitteeRegularInviteeSaveSuccessAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_SAVE_SUCCESS";
    formData: Dtos.CommitteeRegularInvitee;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeRegularInviteeSaveSuccessActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeRegularInviteeSaveSuccessAction;
}

export interface ICommitteeRegularInviteeSaveFailureAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeRegularInviteeSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeRegularInviteeSaveFailureAction;
}

export interface ICommitteeRegularInviteeCreateAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_CREATE",
    committeeId: number
}

export interface ICommitteeRegularInviteeCreateActionCreator {
    (committeeId: number): ICommitteeRegularInviteeCreateAction
}

export interface ICommitteeRegularInviteeCreateSuccessAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_CREATE_SUCCESS";
    formData: Dtos.CommitteeRegularInvitee;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ICommitteeRegularInviteeCreateSuccessActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ICommitteeRegularInviteeCreateSuccessAction;
}

export interface ICommitteeRegularInviteeCreateFailureAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeRegularInviteeCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeRegularInviteeCreateFailureAction;
}

export interface ICommitteeRegularInviteeValidateAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_VALIDATE";
    formData: Dtos.CommitteeRegularInvitee;

}

export interface ICommitteeRegularInviteeValidateActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee
    ): ICommitteeRegularInviteeValidateAction;
}

export interface ICommitteeRegularInviteeValidateSuccessAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_VALIDATE_SUCCESS";
    formData: Dtos.CommitteeRegularInvitee;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ICommitteeRegularInviteeValidateSuccessActionCreator {
    (
        formData: Dtos.CommitteeRegularInvitee,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ICommitteeRegularInviteeValidateSuccessAction;
}

export interface ICommitteeRegularInviteeValidateFailureAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ICommitteeRegularInviteeValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ICommitteeRegularInviteeValidateFailureAction;
}

export interface ICommitteeRegularInviteeClearAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_CLEAR";
    propertiesToClear?: string[];
}

export interface ICommitteeRegularInviteeClearActionCreator {
    (propertiesToClear?: string[]): ICommitteeRegularInviteeClearAction;
}

export interface ICommitteeRegularInviteeFilterActionCreator {
    (formFilter: IFormFilter): ICommitteeRegularInviteeFilterAction;
}

export interface ICommitteeRegularInviteeFilterAction {
    type: "ACTION_COMMITTEEREGULARINVITEE_FILTER";
    formFilter: IFormFilter;
}


export type CommitteeRegularInviteeAction =
    ICommitteeRegularInviteeLoadAction |
    ICommitteeRegularInviteeLoadByIdAction |
    ICommitteeRegularInviteeLoadByCommitteeIdAction |
    ICommitteeRegularInviteeLoadFailureAction |
    ICommitteeRegularInviteeLoadSuccessAction |
    ICommitteeRegularInviteeSaveAction |
    ICommitteeRegularInviteeSaveSuccessAction |
    ICommitteeRegularInviteeSaveFailureAction |
    ICommitteeRegularInviteeCreateAction |
    ICommitteeRegularInviteeCreateSuccessAction |
    ICommitteeRegularInviteeCreateFailureAction |
    ICommitteeRegularInviteeValidateAction |
    ICommitteeRegularInviteeValidateSuccessAction |
    ICommitteeRegularInviteeValidateFailureAction |
    ICommitteeRegularInviteeClearAction | 
    ICommitteeRegularInviteeFilterAction;
